import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations, LANG_CODES } from "./i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "it";
    const saved = window.localStorage.getItem("grappolo_lang");
    if (saved && LANG_CODES.includes(saved)) return saved;
    // Default to Italian on first visit (site is Italian-first)
    return "it";
  });

  const setLang = (next) => {
    if (!LANG_CODES.includes(next)) return;
    setLangState(next);
    try {
      window.localStorage.setItem("grappolo_lang", next);
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] }),
    [lang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
